//THIS COMPONENT IS DISCONTINUED. IT IS USED ONLY AS A FALLBACK
//TO /REPORT URLS WHICH WILL STILL OPEN ON THEIR OWN TABS, HANDLED BY THE BROWSER
//DURING REMOVAL, ENSURE TO VERIFY SYNCFUSION LIBRARY ISN'T USED, AND REMOVE THE PACKAGE

import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { Grid2 } from '@mui/material';
import { setLoading } from '../store/User/UserSlice';
import { getAsset, getDocument } from '../services/apiService';
import { setShowToast } from '../store/Navigation/NavSlice';
import { Layout } from '../components/chrome/Layout';
import { Loading } from '../components';
import { RootState } from '../store';
import { AlertModal } from '../components/shared/alertModal';
import { useTranslationContext } from '../context/TranslationContext';

const envSettings = window as any;

const ReportViewer: React.FC = () => {
    const dispatch = useDispatch();
    const [search] = useSearchParams();
    const { loading } = useSelector((state: RootState) => state.user);
    const [loadFailed, setLoadFailed] = useState(false);
    const [documentName, setDocumentName] = useState("");
    const [documentId, setDocumentId] = useState("");
    const { getFormattedPhrase } = useTranslationContext();

    useEffect(() => {
        const id = search.get("id");
        const pid = search.get("pid"); // for asset this will assetInfoId
        const docId = search.get("did"); // for asset this will version number
        const docName = search.get("dName"); // for asset this will be null
        const reportType = search.get("type");
        
        setDocumentName(docName ?? "");
        setDocumentId(docId ?? "");
        
        if (id && pid && docId) {
            if (reportType === "asset") {
                viewAsset(parseInt(id), parseInt(pid), docId);
            } else {
                viewDocument(parseInt(id), parseInt(pid), parseInt(docId));
            }
        }
        window.scrollTo(0, 0);
    }, []);

    const viewDocument = (
        individualId: number,
        participantId: number,
        documentId: number,
    ) => {
        dispatch(setLoading(true));
        if (participantId && documentId && individualId) {
            getDocument(participantId, documentId, individualId)
                .then(async (res) => {
                    const data = new Blob([res], { type: "application/pdf" });
                    const pdfUrl = window.URL.createObjectURL(data);
                    window.open(pdfUrl, '_blank');
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
                })
                .catch((e) => {
                    setLoadFailed(true);
                    console.error("File Not Found", e);
                })
                .finally(() => {
                    dispatch(setLoading(false));
                });
        }
    };

    const viewAsset = (
        individualId: number,
        assetInfoId: number,
        version: string
    ) => {
        dispatch(setLoading(true));
        if (individualId && assetInfoId && version) {
            getAsset(individualId, assetInfoId, version)
                .then((res) => {
                    const data = new Blob([res], { type: "application/pdf" });
                    const pdfUrl = window.URL.createObjectURL(data);
                    window.open(pdfUrl, '_blank');
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
                })
                .catch((e) => {
                    setLoadFailed(true);
                    console.error("File Not Found", e);
                })
                .finally(() => {
                    dispatch(setLoading(false));
                });
        }
    };

    return (
        <Layout>
            {loading && <Loading />}
            <Grid2 container spacing={0} justifyContent={"center"}>
                <AlertModal 
                    text={getFormattedPhrase("fileError")} 
                    supportMessage={`${documentName} (${documentId})`} 
                    onClose={() => setLoadFailed(false)} 
                    isOpen={loadFailed} 
                />
            </Grid2>
        </Layout>
    );
};

export default ReportViewer;